export function getOrDefault<TKey, TValue> (map: Map<TKey, TValue>, key: TKey, defaultValue: TValue): TValue {
  return map.has(key) ? map.get(key)! : defaultValue
}
